import { CreateNote, Note, NoteDisplay } from '../models/dtos';
import ApiBase from './base/ApiBase'

class NoteClient extends ApiBase {
    private controllerName: string = 'Note';

    async Create(dto: CreateNote, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async Delete(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<Note> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAll(associationId: string, signal?: AbortSignal): Promise<NoteDisplay[]> {
        return this.GetAsync(`${this.controllerName}?AssociationId=${associationId}`, signal);
    }

    static CreateDefaultNote = () => {
        return {
            Id: '',
            AssociationId: '',
            AssociationType: '',
            SystemUserId: '',
            Title: '',
            Content: '',
            IsDeleted: false,
            LastUpdateDate: ''
        };
    };

    static CreateDefaultNoteDisplay = () => {
        return {
            Id: '',
            IsDeleted: false,
            LastUpdateDate: '',
            AssociationId: '',
            AssociationType: '',
            SystemUserId: '',
            Title: '',
            Content: '',
            SystemUserName: ''
        };
    };

};
    
export enum NoteErrors {
    Create = 'Error creating Note',
    Delete = 'Error deleting Note',
    GetAll = 'Error loading Note',
    GetSingle = 'Error loading Note',
    Update = 'Error saving Note',
};

export default NoteClient;